import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../../API/axiosConfig';
import { algorithmCalculation } from '../../../redux/actions/Firebase';
import { DEFAULT_BATCH_COUNTRY } from '../../../config/batchConfig';
import { combineCustomAndRegularBatchDataCodes, findLatestExistingBatchData } from '../../../helperFunctions';
import ChartCalculations from '../BrandPersonas/chartCalculations';
import ReportLayout from '../../../myComponents/report/ReportLayout';

const BrandPersonaReport = () => {
  const { id } = useParams();
  const [state, setState] = useState({ ready: false, persona: null, result: null, meta: [], error: '' });

  useEffect(() => {
    const run = async () => {
      try {
        const { data } = await axios.get('/fs/data');
        const appData = data.result;
        const normalizedAppData = {
          ...appData,
          combinedBatchDataCodes:
            appData?.combinedBatchDataCodes ||
            combineCustomAndRegularBatchDataCodes(appData?.existingBatchData || {}, appData?.customBatchData || {}),
          socialMediaPosts: appData?.socialMediaPosts || appData?.socialPosts || [],
        };
        const persona = (normalizedAppData.brandPersonas || []).find(e => e.id === id);
        if (!persona) throw new Error('Brand persona not found for export.');
        const availableBatchCountries = Object.keys(normalizedAppData?.combinedBatchDataCodes || {});
        const resolvedBatchCountry =
          normalizedAppData?.combinedBatchDataCodes?.[DEFAULT_BATCH_COUNTRY] ? DEFAULT_BATCH_COUNTRY : availableBatchCountries[0];

        if (!resolvedBatchCountry || !normalizedAppData?.combinedBatchDataCodes?.[resolvedBatchCountry]) {
          throw new Error('No batch data available for export.');
        }

        const { latestQuarter, latestYear } = findLatestExistingBatchData(normalizedAppData.combinedBatchDataCodes[resolvedBatchCountry]);
        const batch = { quarter: [latestQuarter], year: latestYear };
        const result = await algorithmCalculation('Brand', { persona, filters: null, batches: batch, batchCountry: resolvedBatchCountry }, () => {}, []);
        setState({
          ready: true,
          persona,
          result,
          error: '',
          meta: [
            { label: 'Persona', value: persona?.Name },
            { label: 'Campaign', value: persona?.Campaign_Name },
            { label: 'Generated', value: new Date().toLocaleString() },
            { label: 'Batch Country', value: resolvedBatchCountry },
          ],
        });
      } catch (error) {
        setState({
          ready: true,
          persona: null,
          result: null,
          error: error?.message || 'Failed to prepare report data.',
          meta: [{ label: 'Generated', value: new Date().toLocaleString() }],
        });
      }
    };
    run();
  }, [id]);

  return (
    <ReportLayout title="Brand Persona Dashboard Report" metadata={state.meta} ready={state.ready} hasError={!!state.error} errorMessage={state.error}>
      {state.result && <ChartCalculations type="brand" data={state.result} brandPersona={state.persona} isSelectedSample />}
      {!state.result && state.error && <p>{state.error}</p>}
    </ReportLayout>
  );
};

export default BrandPersonaReport;
